import { TrlFormattedMessagePlain } from '»utils/i18n';
import { TrlNumberFormatted } from '»utils/number';
import { trlFieldDefaultValue } from '»utils/trlFieldDefaultValue';

export const formatPrimaryTitlePrice = ({
  trancheType,
  priceType,
  price,
  minMaxPrice,
  offerPrice,
  typeNegotiation,
}) => {
  if (trancheType === 'R') return trlFieldDefaultValue();

  if (priceType === 'Q' || priceType === 'T')
    return (
      <TrlNumberFormatted
        value={!price ? (minMaxPrice ?? offerPrice) : trlFieldDefaultValue()}
        endDecorator={typeNegotiation === 'Q' ? '' : ' %'}
        decimalDigits={2}
      />
    );

  return (
    <TrlNumberFormatted
      value={!price ? (minMaxPrice ?? offerPrice) : trlFieldDefaultValue()}
      decimalDigits={2}
    />
  );
};

export const getPriceTypeLabel = ({ value }) => {
  switch (value) {
    case 'Q':
    case 'P':
      return TrlFormattedMessagePlain({ id: 'TRLT_UI-PRICE' });
    case 'T':
      return TrlFormattedMessagePlain({ id: 'TRLT_UI-RATE' });
    default:
      return 'PriceType Unknown';
  }
};
